import Tag, { TagProps } from 'src/components/primitives/Tag/Tag';
import { cj } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';

interface Props extends Omit<TagProps, 'className'>, WithClassName {
	variant:
		| 'new'
		| 'perp'
		| 'coming-soon'
		| 'zero-fees'
		| 'pre-launch'
		| 'leverage'
		| 'long'
		| 'short';
}

/**
 * Provides preset styles for common tags.
 * - Do NOT add a new variant to this component for every tag you come across.
 *   This is specifically for tags that have been defined in the design system.
 * - Do NOT try to override the styles defined here, use the `Tag` component directly instead.
 */
export default function VariantTag({
	variant,
	className,
	children,
	...rest
}: Props) {
	const variantClassName = {
		new: 'bg-warn-orange text-black',
		perp: 'bg-button-secondary-bg-hover text-text-default',
		'coming-soon': 'bg-tooltip-bg text-text-default',
		'zero-fees': 'bg-warn-orange-secondary-bg text-star-yellow',
		'pre-launch': 'bg-button-selector text-text-default',
		leverage: 'bg-purple-bg text-purple-link',
		long: 'bg-positive-green-secondary-bg text-positive-green',
		short: 'bg-negative-red-secondary-bg text-negative-red',
	}[variant];

	const content = (() => {
		if (variant === 'leverage') {
			return children;
		}

		return {
			new: 'New',
			perp: 'Perp',
			'coming-soon': 'Coming Soon',
			'zero-fees': '0% Fees',
			'pre-launch': 'Pre Launch',
			long: 'Long',
			short: 'Short',
		}[variant];
	})();

	return (
		<Tag className={cj(variantClassName, className)} {...rest}>
			{content}
		</Tag>
	);
}
